/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */

import * as d3 from 'd3';

export function centerTextsVertically(texts) {
  texts.each(function () {
    const text = d3.select(this),
      tspans = text.selectAll('tspan'),
      lineCount = tspans.size();

    if (lineCount < 2) {
      return;
    }

    const textNode = text.node(),
      height = textNode.getBBox().height,
      lineHeight = height / lineCount,
      adjustment = (lineHeight * (lineCount - 1)) / 2,
      g = findParentElement(textNode, 'g');

    if (g === null) {
      console.error('No parent "g" element found for text: ' + text.text());
      return;
    }

    const transform = g.transform;
    if (transform === null) {
      console.error(
        'Parent "g" element has no tranform, for text: ' + text.text()
      );
      return;
    }

    try {
      // f in the transform matrix is the vertical adjustment
      transform.baseVal[0].matrix.f -= adjustment;
    } catch (err) {
      console.error(
        'Parent "g" element transform adjustment failed for text: ' +
          text.text(),
        err
      );
    }
  });
}

export function findParentElement(child, nodeName) {
  while (child != null && child.nodeName !== nodeName) {
    child = child.parentNode;
  }
  return child;
}

export function svgWidth(svg) {
  try {
    // Firefox does not report with of svg properly when set by percentage,
    // so get width of container, meaning we must use margins around container,
    // and not padding, so the container and svg are the same size.
    return svg.parentNode.clientWidth;
  } catch (err) {
    console.error('Unable to get svg width for ' + svg, err);
    return 800; // default some value in this rare case
  }
}

export function wrapText(texts, width) {
  texts.each(function () {
    let text = d3.select(this),
      words = text.text().split(/[ -]+/).reverse(),
      word,
      line = [],
      lineNumber = 0,
      lineHeight = 1.1, // ems
      y = text.attr('y'),
      dy = parseFloat(text.attr('dy') || 0),
      tspan = text
        .text(null)
        .append('tspan')
        .attr('x', 0)
        .attr('y', y)
        .attr('dy', dy + 'em');

    while ((word = words.pop())) {
      // eslint-disable-line no-cond-assign
      line.push(word);
      tspan.text(line.join(' '));
      if (tspan.node().getComputedTextLength() > width) {
        line.pop();
        tspan.text(line.join(' '));
        line = [word];
        tspan = text
          .append('tspan')
          .attr('x', 0)
          .attr('y', y)
          .attr('dy', ++lineNumber * lineHeight + dy + 'em')
          .text(word);
      }
    }
  });
}
